// Custom error class for server connection issues
export class ServerConnectionError extends Error {
  constructor(message: string = 'Could not connect to the server. Please make sure the server is reachable from your machine') {
    super(message);
    this.name = 'ServerConnectionError';
  }
}

// Helper function to redirect to server error page
export const redirectToServerError = () => {
  // Use window.location to ensure we navigate even if React Router isn't available
  window.location.href = '/server-error';
};

// Helper function to check if an error should trigger a server error redirect
export const shouldRedirectToServerError = (error: unknown): boolean => {
  return error instanceof ServerConnectionError;
};
